import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faQrcode, faMedal, faClockFour, faListUl, faPlay, faCheck, faFile, faFileAlt, faMusic, faImagePortrait, faToolbox } from '@fortawesome/free-solid-svg-icons';
import './FocusTimerHome.css';
// import focustimerimage from '../../assets/pageimages/FocusTimer.png';
import FocusTimerAbout from './FocusTimerAbout';

function FocusTimerHome() {

  return (
    <div className='bg-black'>
      <div className="py-2 bg-black mt-2">
        <div className="border-b border-blue-300 mb-8">
            <h2 className='text-xl lg:text-2xl font-bold text-yellow-200 text-center mb-2'>FocusTimer</h2>
        </div>

          <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-250">
            <CardLink to="/focus-timer-start" icon={faPlay} text="Start" />
            {/* <CardLink to="/focus-timer-mypomodoro" icon={faListUl} text="My Pomodoro" /> */}
            {/* <CardLink to="/focus-timer-approvals" icon={faMedal} text="Approvals" />
            <CardLink to="/focus-timer-mybadges" icon={faMedal} text="My Badges" />
            <CardLink to="/focus-timer-myreports" icon={faMedal} text="My Reports" />
            <CardLink to="/focus-timer-teamreports" icon={faMedal} text="Team Reports" />
            <CardLink to="/focus-timer-mywhitenoises" icon={faMedal} text="My White Noises" />
            <CardLink to="/focus-timer-mywallpapers" icon={faMedal} text="My Wallpapers" />
            <CardLink to="/focus-timer-mysettings" icon={faMedal} text="Settings" /> */}

            <CardNoLink to="" icon={faListUl} text="My Pomodoro" />
            <CardNoLink to="" icon={faCheck} text="Approvals" />
            <CardNoLink to="" icon={faMedal} text="My Badges" />
            <CardNoLink to="" icon={faFile} text="My Reports" />
            <CardNoLink to="" icon={faFileAlt} text="Team Reports" />
            <CardNoLink to="" icon={faMusic} text="My White Noises" />
            <CardNoLink to="" icon={faImagePortrait} text="My Wallpapers" />
            <CardNoLink to="" icon={faToolbox} text="Settings" />
          </div>
        </div>
        <div className="flex justify-center items-center">
           <FocusTimerAbout/>
        </div>
        <footer className="bg-gray-900 border-t border-blue-400 text-gray-400 py-4">
          <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/about-us" className="hover:text-teal-300">About</Link>
              <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
              <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
              <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
            </div>
          </div>
        </footer>        
    </div>
  );
};

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default FocusTimerHome;
